import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import { BackupRestoreContent } from "../Component/BackupRestoreContent";

const BackupRestore = () => {
  const seoData = getSEOData("/backup-restore");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <BackupRestoreContent />
    </>
  );
};

export default BackupRestore;
